'use strict';

import TextView from 'views/record/subfields/Text';

class PasswordField extends TextView{
}


export default PasswordField;
